module.exports = __webpack_public_path__ + "static/img/Hotline1.09b99135.png";